export const m = {
  EnterID: "Fare clic per inserire l'ID Tada",
  "select-specifications":
    "Fare clic per selezionare le specifiche di ricarica",
  "check-account": "Controlla il conto di ricarica",
  whatID: "Che cos'è un ID Tada?",
  getID: "Inserisci l'ID Tada",
  maskgetID: "Inserisci l'ID Tada",
  "toastTips-format-error": "Formato di input errato",
  "toastTips-no-exist": "L'ID non esiste",
  toastTipsPlease: "Si prega di controllare prima il conto di ricarica",
  "common-problem": "problema comune",
  "transaction-succeeded": "Commercio di successo",
  "transaction-failed": "transazione fallita",
  "transaction-cancel": "Annullamento della transazione",
  "whether-account":
    "1.Come posso verificare se è presente nell'account dopo averlo ricaricato?",
  "answer-whether-account":
    "Dopo la ricarica, puoi tornare a [Mio] - [portafoglio] dell'app per visualizzare i diamanti",
  "no-account": "2.Cosa devo fare se non mi pagano dopo la ricarica?",
  "answer-no-account":
    "Invia le tue domande in [messaggio] - [messaggio ufficiale] - [feedback e guida] dell'app e fornisci le seguenti informazioni. Il nostro servizio clienti ti aiuterà.",
  "recharge-money": "1. Ricarica l'importo e l'ID conto",
  "recharge-time": "2. Ora e data della ricarica",
  "recharge-shot": "3. Schermata del pagamento riuscito",
  "recharge-wrong": "3.Come addebitare l'account e l'importo errati",
  "answer-recharge-wrong":
    "Prima di inserire la password di pagamento, si prega di confermare con attenzione l'ID dell'account di ricarica e le informazioni sull'importo della ricarica prima dell'acquisto. L'importo addebitato non può essere restituito. Per l'account addebitato, puoi provare a contattare l'utente ID della ricarica effettiva e negoziare con l'altra parte se sei disposto a compensare la ricarica.",
  refund: "4.Rimborso",
  "answer-refund":
    "Mi dispiace! Tada al momento non supporta alcuna forma di rimborso.",
  "buy-enter-link":
    'I diamanti possono essere ricaricati tramite il link, <a class="web-link" href="https://pay.tadachat.live/" >https://pay.tadachat.live</a> Copia il link e aprilo nel browser mobile, accedi alla pagina di acquisto, controlla il numero di conto, seleziona le specifiche corrispondenti e usa il metodo di pagamento appropriato per pagare - più sconti!',
  "buy-notice-a":
    "Nota:<a>pay.tadachat.live</a> è l'unico sito ufficiale di Tada per l'acquisto di diamanti",
  replace: "Sostituire",
  sureBtn: "OK",
  "pay-style": "scegli il metodo di pagamento",
  goBack: "Torna alla homepage",
  toastTips: "Inserisci l'ID Tada",
  rechargeFAQ_title: "problema comune",
  PayStatusSuccess_title: "Commercio di successo",
  PayStatusFail_title: "transazione fallita",
  PayStatusCancel_title: "Annullamento della transazione",
  Diamonds_title: "Sito ufficiale di ricarica diamante Tada",
  "buy-notice":
    "Nota: pay.Tadachat.live è l'unico sito ufficiale di acquisto di diamanti di Tada, si prega di andare a The Message - Official News - Feedback and Help",
  RechargeHelp_title: "Ricarica aiuto",
  openAPP: "Apri l'APP Tada",
  "buy-diamonds-tit": "Acquista servizi di diamanti",
  description:
    "Tada è l'unico sito ufficiale di ricarica di diamanti. Tada è un social software internazionale. Gli utenti in oltre 150 paesi e regioni utilizzano il Tada",
  keywords:
    "Ricarica Tada, ricarica diamante Tada, ricarica ufficiale Tada, sito web ricarica ufficiale Tada",
  payforType: "Metodo di ricarica",
  trueText: "OK",
  falseText: "annullare",
  alertShowTxt1: "Sei sicuro di utilizzare",
  alertShowTxt3: "per ricaricare",
  alertShowTxt5: "diamanti?",

  EnterIDTip: "Ricarica rapida Tada",

  scanLogin:
    "Per la privacy e la sicurezza dell'account, scansiona il codice per accedere",
  scanTip:
    'Suggerimento: fai clic su "Scansiona" nell\'angolo in alto a destra di Tada "Centro personale / Dinamica" per scansionare il codice per accedere. Allo stesso tempo, supporta l\'accesso identificando lo screenshot del codice QR',
  scanVersion:
    "Aggiorna Tada alla versione %s e scansiona il codice per accedere",
  delAccount: "Cancellazione dell'account",
  logout: "Disconnessione",
  submit: "Inviare",
  email_place_holder: "Inserisci la tua casella di posta",
  contact_email: "Contatto email",
  provide_email:
    "Fornisci il tuo indirizzo email per ricevere la notifica di pagamento",
  email_address: "Indirizzo e-mail",
};



// WEBPACK FOOTER //
// ./src/lang/it.js